<template>
  <div>
    <div class="content-box my-cource">
      <div class="content-box-title">
        课程详情
      </div>
      <div class="cource">
        <div class="cource-list-tool">
          <div @click="getList(1)" :class="{ active: currentType == 1 }">
            VCT
          </div>
          <div @click="getList(3)" :class="{ active: currentType == 3 }">WBT</div>
          <div @click="getList(2)" :class="{ active: currentType == 2 }">Mini Video</div>
        </div>
        <div class="cource-list">
          <div class="cource-list-item">
            <div class="name">课程名称</div>
            <div class="num">参训人数</div>
            <div class="num">PC数量</div>
          </div>
          <div class="cource-list-item" v-for="(item, i) in dataList" :key="i">
            <div class="name">{{ item.courseName }}</div>
            <div class="num">{{ item.userNum }}</div>
            <div class="num">{{ item.dealerNum }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { getMonthDetail } from '@/api/common/index.js'

export default {
  name: 'Course',
  data() {
    return {
      currentType: 1,
      dataList: [],
    }
  },
  created() {},
  methods: {
    getList(type) {
      this.currentType = type
      getMonthDetail({
        month: this.$route.query.id,
        courseSource: type,
      }).then((res) => {
        console.log(res)
        this.dataList = res.rows
      })
      // if (type == 1) {
      //   this.dataList = [
      //     {
      //       name: 'ET/AT - 冷却液',
      //       people: '55',
      //       pc: '50',
      //     },
      //     {
      //       name: 'Paint Central Billing Launch Training',
      //       people: '55',
      //       pc: '50',
      //     },
      //     {
      //       name: 'PL - 冬季新品',
      //       people: '77',
      //       pc: '44',
      //     },
      //     {
      //       name: 'PL - 夏季新品',
      //       people: '88',
      //       pc: '77',
      //     },
      //     {
      //       name: 'PL - 春季新品 ',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: 'TEQ Selling Skill Online Training',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '仪表警示灯介绍 -1',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '仪表警示灯介绍 -2',
      //       people: '15',
      //       pc: '10',
      //     },
      //   ]
      // } else if (type == 2) {
      //   this.dataList = [
      //     {
      //       name: '00 问候及引言',
      //       people: '89',
      //       pc: '80',
      //     },
      //     {
      //       name: '01 什么是保时捷的待客方法',
      //       people: '80',
      //       pc: '70',
      //     },
      //     {
      //       name: '02 独特性和奢侈品基本知识',
      //       people: '90',
      //       pc: '70',
      //     },
      //     {
      //       name: '03 保时捷礼仪及行为指导原则',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '04 着装标准和形象',
      //       people: '80',
      //       pc: '70',
      //     },
      //     {
      //       name: '05 服务顾问助理的一天',
      //       people: '80',
      //       pc: '80',
      //     },
      //     {
      //       name: '06 电话沟通礼仪 ',
      //       people: '70',
      //       pc: '70',
      //     },
      //     {
      //       name: '健康、安全与环境WBT',
      //       people: '75',
      //       pc: '70',
      //     },
      //     {
      //       name: '保时捷保修基础培训WBT',
      //       people: '65',
      //       pc: '60',
      //     },
      //   ]
      // } else if (type == 3) {
      //   this.dataList = [
      //     {
      //       name: '普通零配件-制动盘片',
      //       people: '40',
      //       pc: '40',
      //     },
      //     {
      //       name: '普通零配件-制动液',
      //       people: '20',
      //       pc: '10',
      //     },
      //     {
      //       name: '普通零配件-火花塞',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '普通零配件-空调滤清器',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '本地产品-联合品牌机油',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '本地产品-陶瓷太阳膜',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '本地产品-漆面保护膜',
      //       people: '15',
      //       pc: '10',
      //     },
      //     {
      //       name: '本地产品-保时捷认证轮胎',
      //       people: '14',
      //       pc: '10',
      //     },
      //     {
      //       name: '服务产品-保时捷服务套餐',
      //       people: '17',
      //       pc: '12',
      //     },
      //   ]
      // }
    },
  },
  mounted() {
    this.getList(1)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.my-cource {
  min-height: 300px;
  background-size: contain;
}
.cource {
  &-list-item {
    .name {
      display: inline-block;
      color: #000;
      width: 200px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // word-break: keep-all;
      // white-space: nowrap;
    }
    .num {
      width: 60px;
      text-align: center;
      color: #d5001c;
    }
  }
}
</style>
